"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const Approach = () => {
  return (
    <div>
      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-screen-xl mx-5 lg:mx-auto">
          <div className="text-center mb-6 md:mb-12">
            <p className=" text-6xl text-black font-bold ">Our Approach</p>
          </div>
          <Image
            alt=""
            src="/images/process.png"
            className=" object-cover"
            width={1800}
            height={573}
          />
          {/* <div className="grid grid-cols-1 gap-3 md:gap-6 lg:gap-16 items-center justify-between">
            <div>
              <ol className="relative border-s border-gray-400 ">
                <li className="mb-10 ms-4 bg-blue-600 hover:bg-gray-500 p-4 md:p-8 text-white">
                  <div className="absolute w-5 h-5 bg-gray-500 hover:bg-lime-400 rounded-full mt-1.5 -start-2.5 "></div>
                  <h3 className="font-semibold mb-2">Listen</h3>
                  <p className="text-base mb-1">
                    We start by understanding your specific needs and challenges
                  </p>
                </li>
                <li className="mb-10 ms-4 bg-blue-600 hover:bg-gray-500 p-4 md:p-8 text-white">
                  <div className="absolute w-5 h-5 bg-gray-500 hover:bg-lime-400 rounded-full mt-1.5 -start-2.5 "></div>
                  <h3 className="font-semibold mb-2">Innovate</h3>
                  <p className="text-base mb-1">
                    We develop creative, tailored solutions
                  </p>
                </li>
                <li className="mb-10 ms-4 bg-blue-600 hover:bg-gray-500 p-4 md:p-8 text-white">
                  <div className="absolute w-5 h-5 bg-gray-500 hover:bg-lime-400 rounded-full mt-1.5 -start-2.5 "></div>
                  <h3 className="font-semibold mb-2">Execute</h3>
                  <p className="text-base mb-1">
                    We bring those solutions to life with precision and flair
                  </p>
                </li>
                <li className="ms-4 bg-blue-600 hover:bg-gray-500 p-4 md:p-8 text-white">
                  <div className="absolute w-5 h-5 bg-gray-500 hover:bg-lime-400 rounded-full mt-1.5 -start-2.5 "></div>
                  <h3 className="font-semibold mb-2">Analyze</h3>
                  <p className="text-base mb-1">
                    We measure outcomes and provide insights for continuous
                    improvement
                  </p>
                </li>
              </ol>
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Approach;
